import ability from './ability'

export const canNavigate = to => to.matched.some(route => route.meta.action === 'monitorcontabil'
|| ability.can(route.meta.action, route.meta.resource))

export const _ = undefined
